import { CxEvent } from '@spartacus/core';

export class Ga4GgCheckoutShippingAddressSelectedEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    currency?: string;
    coupon?: string;
    value?: number;
    items?: {
      item_id?: string;
      item_name?: string;
      discount?: string;
      coupon?: string;
      price?: number;
      quantity?: number;
    }[];
  } | null;
}
